<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xs="12">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="pl-3 banner-title blue--text">
            Dashboard
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3" class="pt-2 mb-2">
        <v-card
          class="mx-auto"
          max-width="344"
          min-height="120"
          outlined
          color="#D1C4E9"
        >
          <v-list-item three-line>
            <v-list-item-avatar
              tile
              size="80"
              color="teal lighten-5"
              class="overflow-hidden mt-n3 elevation-6"
            >
              <v-icon large color="blue darken-4 darken-2">
                mdi-truck-delivery
              </v-icon></v-list-item-avatar
            >
            <v-list-item-content>
              <div class="text-overline mb-4">
                TOTAL DELIVERIES TODAY
              </div>
              <v-list-item-subtitle>By DO</v-list-item-subtitle>
              <v-list-item-title class="text-h5 mb-1">
                1,000
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" class="pt-2 mb-2">
        <v-card class="mx-auto" max-width="344" outlined color="#E0F2F1">
          <v-list-item three-line>
            <v-list-item-avatar
              tile
              size="80"
              color="teal lighten-5"
              class="overflow-hidden mt-n3 elevation-6"
            >
              <v-icon large color="blue darken-4 darken-2">
                mdi-truck-cargo-container
              </v-icon></v-list-item-avatar
            >
            <v-list-item-content>
              <div class="text-overline mb-4">
                TOTAL TRANSIT DELIVERIES TODAY
              </div>
              <v-list-item-subtitle>By DO</v-list-item-subtitle>
              <v-list-item-title class="text-h5 mb-1">
                10,000
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" class="pt-2 mb-2">
        <v-card
          class="mx-auto"
          max-width="344"
          min-height="120"
          outlined
          color="#80D8FF"
        >
          <v-list-item three-line>
            <v-list-item-avatar
              tile
              size="80"
              color="teal lighten-5"
              class="overflow-hidden mt-n3 elevation-6"
            >
              <v-icon large color="blue darken-4 darken-2">
                mdi-truck-delivery
              </v-icon></v-list-item-avatar
            >
            <v-list-item-content>
              <div class="text-overline mb-4">
                TOTAL DELIVERIES TODAY
              </div>
              <v-list-item-subtitle>By Cargo</v-list-item-subtitle>
              <v-list-item-title class="text-h5 mb-1">
                7,000
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3" class="pt-2 mb-2">
        <v-card class="mx-auto" max-width="344" outlined color="#80CBC4">
          <v-list-item three-line>
            <v-list-item-avatar
              tile
              size="80"
              color="teal lighten-5"
              class="overflow-hidden mt-n3 elevation-6"
            >
              <v-icon large color="blue darken-4 darken-2">
                mdi-truck-cargo-container
              </v-icon></v-list-item-avatar
            >
            <v-list-item-content>
              <div class="text-overline mb-4">
                TOTAL TRANSIT DELIVERIES TODAY
              </div>
              <v-list-item-subtitle>By Cargo</v-list-item-subtitle>
              <v-list-item-title class="text-h5 mb-1">
                5,000
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <h2>6 days snapshot of total delivery count</h2>
        <!-- <canvas id="bar-chart"></canvas>-->
        <bar-chart />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

//import planetChartData from "../../config/chart-data.js";
import BarChart from "./charts/BarChart.vue";
import moment from "moment";
const departedVessel = createNamespacedHelpers("departed_vessels");
const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");
const reportingNamespace = createNamespacedHelpers("reporting");

export default {
  name: "dashboard",
  components: {
    BarChart
  },
  data: () => ({
    current_date: moment().format("YYYY-MM-DD")
    // chart_data: planetChartData
  }),
  computed: {
    ...departedVessel.mapState({
      departed_vessels: state => state.departed_vessels,
      selected_vessel: state => state.selected_vessel
    }),

    ...deliveryOrderNamespace.mapState({
     // delivery_orders: state =>
     //   state.delivery_orders ? state.delivery_orders : [],
    //  delivery_order_items: state => (state.do_items ? state.do_items : []),
     // loading: state => state.loading,
     // loading_do_items: state => state.loading_do_items
    }),

    ...reportingNamespace.mapState({
      report_weekly_sales_count: state => state.report_weekly_sales_count
    })
  },
  mounted() {
    this.loadData();
    //console.log("chart data", this.chart_data);
    //this.loadChart();
   // console.log("loading", this.loading);
  },
  methods: {
    ...reportingNamespace.mapActions(["aGetWeeklySalesCount"]),
    loadChart() {
      // const ctx = document.getElementById("bar-chart");
      // new Chart(ctx, this.chart_data);
    },
    loadData() {
      const params = {
        today: this.current_date
      };
      const delivery_count = this.aGetWeeklySalesCount(params);
      Promise.resolve(delivery_count).then(function(value) {
        console.log("from dashboard", value);
      });
    //  console.log("load data", this.report_weekly_sales_count);
    }
  }
};
</script>

<style></style>
